// extracted by mini-css-extract-plugin
export default {"container":"MultiSelect__container--2Ed","button":"MultiSelect__button--2Wk"};